import React from 'react';
import { useLayoutEffect } from 'react';

import { useTheme } from '@mui/material/styles';
import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';

import Typography from '@mui/material/Typography';
import Zoom from '@mui/material/Zoom';
import Collapse from '@mui/material/Collapse';

import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import HelpIcon from '@mui/icons-material/Help';
import Checkbox from '@mui/material/Checkbox';

import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';

import MeldungWurdeVersandt from '../Components/MeldungWurdeVersandt';

import CustomTextFieldNGX from '../Components/CustomTextFieldNGX';
import CustomList from '../Components/CustomList';
import CustomDatePickerFieldNGX from "../Components/CustomDatePickerFieldNGX";
import DokumenteUploader from './DokumenteUploader';

import UnterschriftHaken from '../Components/UnterschriftHaken';
import personEntity from '../Entity/person';
import ortEntity from '../Entity/ort';
import Person from '../Components/Person';
import Ort from '../Components/Ort';
import Spezies from '../Components/Spezies';
import Fehlerbox from '../Components/Fehlerbox';
import F04_WareCodes from '../Components/Cites/F04_WareCodes';
import AutocompleteLand from '../Components/Cites/AutocompleteLand';

import CreatureEntity from '../Entity/Creature';
import CreatureConfigFields from '../Entity/CreatureConfigFields';
import Creatures from '../Components/Creatures';
import SpeziesEntity from '../Entity/Kennzeichnung/Spezies';

import rulesText from '../Entity/rulesText';
import ValidatorInputText from '../Module/Validatoren/ValidatorInputText';
import validatorResult from '../Entity/validatorResult';

//import ListeHerkunftCodes from '../Components/Cites/ListeHerkunftCodesFauna';

import CitesMetadaten from "../Entity/CitesMetadaten";

import {
  Standard as StandardDataField
} from "../Entity/Kennzeichnung/StandardDataFields";

import {speziesSetzenCites, anzahlSpeziesSetzen, addEntityToState} from '../Actions';
import ValidatorPerson from '../Module/Validatoren/ValidatorPerson';
import ValidatorOrt from '../Module/Validatoren/ValidatorOrt';

const style = {
    paper: {
      padding:"10px 20px 10px 20px",
    },
    paperHeavy: {
      padding:"10px 20px 10px 20px",
    },
    paperAktiv: {
      padding:"10px 20px 10px 20px",
      backgroundColor:"#fcffc9",
    },
    checkboxItem: {
      paddingTop:"18px",
    },
    FormNumber: {
      display:"inline-block",
      border:"2px solid black",
      padding:"0 5px 0 5px",
    },
  }

const configCreatureExemplar = () => {
    let crtrConf = CreatureConfigFields()
    crtrConf.spezies = false;
    let crtr = CreatureEntity(crtrConf)
    crtr.zeigeAnzahl = false;
    crtr.kennzeichnungAnpassen.spezies = false
    crtr.kennzeichnungAnpassen.geschlechtsverhaeltnis = true
    return crtr;
}

const configHalter = (touched) => {
    let halter = personEntity(touched)
    return halter;
}

const constructor = (props) => {
    props.data.CitesMetadaten = CitesMetadaten()
    props.data.antragsteller = configHalter()
    props.data.antragsteller.personTyp.display = true
    props.data.spezies = SpeziesEntity()
    props.data.anzahl = 1
    props.data.lebend_oder_teil = StandardDataField()
    props.data.marktwert = StandardDataField()
    props.data.haltungsort_vorgeschrieben = StandardDataField()
    props.data.code = StandardDataField()
    props.data.creatures = {}
    let crtr = configCreatureExemplar()
    props.data.creatures[crtr.uniqueId] = crtr
    props.data.art_der_bescheinigung = StandardDataField()
    props.data.art_der_bescheinigung_info_zeigen = StandardDataField(false)

    props.data.herkunftsland = {}
    props.data.herkunftsland.code = StandardDataField()
    props.data.herkunftsland.de = StandardDataField()
    props.data.herkunftsland.eu = StandardDataField()

    props.data.ursprungsland = {}
    props.data.ursprungsland.code = StandardDataField()
    props.data.ursprungsland.de = StandardDataField()
    props.data.ursprungsland.eu = StandardDataField()

    props.data.cites_bescheinigung_rechtmaessiger_erwerb_dokumente = {}
    props.data.cites_bescheinigung_rechtmaessiger_erwerb_nummer = StandardDataField()
    props.data.cites_bescheinigung_rechtmaessiger_erwerb_ausstellungsdatum = StandardDataField()

    props.data.einfuhrgenehmigung_dokumente = {}
    props.data.einfuhrgenehmigung_nummer = StandardDataField()
    props.data.einfuhrgenehmigung_ausstellungsdatum = StandardDataField()

    props.data.ausfuhrgenehmigung_dokumente = {}
    props.data.ausfuhrgenehmigung_nummer = StandardDataField()
    props.data.ausfuhrgenehmigung_ausstellungsdatum = StandardDataField()

    props.data.codeHerkunft = StandardDataField("")
    
    props.data.dokumente_herkunft = {}

    props.updateStandard()('meta')('ready')(true)

}

const touchAll = (obj, group, props) => {
    for (let item in obj) {
      props.updateStandard('touched')(group)(item)(true)
    }
}

const validatorPersonResult = (person, checkPersoPass=false) => {

    if (!person.meta.touched) {
      return []
    }

    var res = ValidatorPerson(person, checkPersoPass)
    if ( res.valid === true ) {
      return [];
    }

    var display = [];
    res.message.map(
    (el) => display.push(<p key={el}>{el}</p>)
    )

    return display;

}

const validatorOrtResult = (haltungsort) => {
    if (!haltungsort.meta.touched) {
      return []
    }

    var res = ValidatorOrt(haltungsort)

    if ( res.valid === true ) {
      return [];
    }
    var display = [];
    res.message.map(
      (el) => display.push(<p key={el}>{el}</p>)
    )

    return display;
  }

const buttonPruefen = (label, props) => (
    <Button
      onClick={()=>{
        props.updateStandard('value')('meta')('touched')(true)

        if (props.data.hasOwnProperty("antragsteller")) {
          touchAll(props.data.antragsteller, 'antragsteller', props)
        }

        if (props.data.hasOwnProperty("eigentuemer")) {
            touchAll(props.data.eigentuemer, 'eigentuemer', props)
        }

        props.updateStandard('touched')('spezies')()(true)

        if (props.data.hasOwnProperty("F02_Haltungsort")) {
            touchAll(props.data.F02_Haltungsort, 'F02_Haltungsort', props)
        }

        if (props.data.hasOwnProperty("nettomasse")) {
            props.updateStandard('touched')('nettomasse')()(true)
        }
        if (props.data.hasOwnProperty("menge")) {
            props.updateStandard('touched')('menge')()(true)
        }
        props.updateStandard('touched')('code')()(true)

        if (props.data.hasOwnProperty("creatures") && Object.keys(props.data.creatures).length > 0) {
            Object.keys(props.data.creatures).map(
                (element) => {
                    //touchAll(props.data.creatures[element], "creatures."+element)
                }
            )
        }

        props.updateStandard('touched')('herkunftsland')('code')(true)
        props.updateStandard('touched')('ursprungsland')('code')(true)
        props.updateStandard('touched')('codeHerkunft')()(true)

      }}
      variant="contained"
      color="primary"
      size="large"
      fullWidth={true}
    >
      &nbsp;<br/> {label}<br/>&nbsp;
    </Button>
)

const absenden = (props) => {

    if (props.data.meta.touched.value !== true) {
        return buttonPruefen("Angaben Prüfen", props);
    }

    var msg = []

    if ( 
        props.data.hasOwnProperty("antragsteller") &&
        !ValidatorPerson(props.data.antragsteller).valid 
    ) {
        msg.push(
        <p key="ERR.antragsteller">
            Fehler bei Angaben zum Antragssteller. Bitte korrigieren Sie zunächst die markierten Felder.
        </p>
        )
    }

    if ( 
        props.data.hasOwnProperty("eigentuemer") &&
        !ValidatorPerson(props.data.eigentuemer).valid 
    ) {
        msg.push(
        <p key="ERR.eigentuemer">
            Fehler bei Angaben zum Eigentümer. Bitte korrigieren Sie zunächst die markierten Felder.
        </p>
        )
    }

    if (!props.data.spezies.wiss) {
        msg.push(
          <p key="ERR.spezies">
            Bitte angeben: Spezies.
          </p>
        )
    }

    if (!props.data.lebend_oder_teil.value) {
        msg.push(
          <p key="ERR.lebend_oder_teil">
            Bitte angeben: Lebendes Exemplar oder Teile und Erzeugnisse.
          </p>
        )
    }

    if (
        props.data.hasOwnProperty("menge") &&
        !props.data.menge.value
    ) {
        msg.push(
          <p key="ERR.menge">
            Bitte angeben: Menge.
          </p>
        )
    }

    if (!props.data.code.value) {
        msg.push(
          <p key="ERR.code">
            Bitte angeben: Code gemäß Anhang VII der Verordnung (EG) Nr. 865/2006.
          </p>
        )
    }

    if (props.data.lebend_oder_teil.value == "lebend" && !props.data.haltungsort_vorgeschrieben.value) {
        msg.push(
          <p key="ERR.haltungsort_vorgeschrieben">
            Bitte angeben: Ist der Haltungsort vorgeschrieben.
          </p>
        )
    }

    if (!props.data.art_der_bescheinigung.value) {
        msg.push(
          <p key="ERR.art_der_bescheinigung">
            Bitte angeben: Art der Bescheinigung (Rechtmäßiger Erwerb/Kommerzielle Tätigkeit/Verbringung lebender Exemplare).
          </p>
        )
    }

    for (let index in props.data.creatures) {
        if (true === false) {
            msg.push(
                <p key={"ERR.Spec"+index}>
                    Fehlermeldung ({index}).
                </p>
            )
        }
    }

    if (!props.data.herkunftsland.code.value) {
        msg.push(
          <p key="ERR.herkunftsland">
            Bitte angeben: Einfuhrmitgliedsstaat.
          </p>
        )
    }

    if (!props.data.herkunftsland.eu.value && !props.data.ursprungsland.code.value) {
        msg.push(
          <p key="ERR.ursprungsland">
            Bitte angeben: Ursprungsland.
          </p>
        )
    }
/*
    if (!props.data.codeHerkunft.value) {
        msg.push(
          <p key="ERR.codeHerkunft">
            Bitte angeben: Code Herkunft.
          </p>
        )
    }
*/
    if ( 
        props.data.meta.unterschrifthaken.value !== true
    ) {
        msg.push(
          <p key="ERR.UnterschriftHaken">
            Bitte bestätigen Sie, dass Ihre Angaben richtig und vollständig sind.
          </p>
        )
    }

    if (msg.length < 1) {
        return props.absenden(
        "Jetzt rechtsverbindlich einreichen/abschicken.",
        false,
        ()=>props.updateStandard('value')('meta')('wurdeVersandt')(true)
        )
    } else {
        return (
        <div>
            <Fehlerbox
            inhalt={msg}
            />
            <div style={{marginTop:"25px"}}></div>
            {props.absenden(
            "Jetzt rechtsverbindlich einreichen/abschicken.", 
            true,
            ()=>props.updateStandard('value')('meta')('wurdeVersandt')(true)
            )}
        </div>
        )
    }

}



const render = (props) => {

    useLayoutEffect(() => {
        constructor(props)
      }, []);

    const theme = useTheme();

    if (!props.data.hasOwnProperty("meta") || props.data.meta.ready !== true) {
        return (
            <div>
                Der Antrag wird vorbereitet.
            </div>
        );
    }

    if (props.data.meta.wurdeVersandt.value) {
        return (
            <MeldungWurdeVersandt>
                Der Antrag wurde versandt.
            </MeldungWurdeVersandt>
        );
    }

    return (
        <div>
        {props.titel}

        <div style={{marginTop:"25px"}}></div>

        <div style={{marginTop:"25px"}}>
            <Person
                id="PersonAntragsteller"
                headline="Antragsteller: Wer sind sie?"
                withCard={true}
                withAvatar={false}
                data={props.data.antragsteller}
                updaterValue={props.updateStandard('value')('antragsteller')}
                updaterTouch={props.updateStandard('touched')('antragsteller')}
                updaterValid={props.updateStandard('valid')('antragsteller')}
                updaterMsg={props.updateStandard('msg')('antragsteller')}
                restLadePlz={props.konfiguration.restPath + 'plz.php'}
                fehlermeldung={validatorPersonResult(props.data.antragsteller, true)}
                konfiguration = {props.konfiguration.importierteKonfiguration.halter}
            />

            <div style={{marginTop:"25px"}}></div>
            <Paper style={style.paperHeavy}>
                <FormControl component="fieldset">
                    <FormLabel component="legend">Sind Antragsteller und Eigentümer identisch?</FormLabel>
                    <FormGroup aria-label="position" row>

                        <FormControlLabel
                            value="top"
                            control={
                                <Checkbox
                                    onChange={()=>{
                                        props.removeStandard(['eigentuemer'])()()
                                    }}
                                    checked={!props.data.hasOwnProperty('eigentuemer')}
                                    sx={{ '& .MuiSvgIcon-root': { fontSize: 28 }}}
                                />
                            }
                            label="Antragsteller und Eigentümer sind identisch."
                            labelPlacement="end"
                        />

                        <FormControlLabel
                            value="top"
                            control={
                                <Checkbox
                                    onChange={()=>{
                                        let eigentuemer = configHalter()
                                        eigentuemer.personTyp.display = true
                                        props.updateStandard()('eigentuemer')()(eigentuemer)
                                    }}
                                    checked={props.data.hasOwnProperty('eigentuemer')}
                                    sx={{ '& .MuiSvgIcon-root': { fontSize: 28 }}}
                                />
                            }
                            label="Eigentümer weicht vom Antragsteller ab"
                            labelPlacement="end"
                        />

                    </FormGroup>
                </FormControl>
            </Paper>
        </div>



        {props.data.hasOwnProperty("eigentuemer") &&
        <Zoom in={true} timeout={500}>
            <div>
                <div style={{marginTop:"25px"}}></div>
                <Person
                    id="PersonEigentuemer"
                    headline="Eigentümer"
                    withCard={true}
                    withAvatar={false}
                    data={props.data.eigentuemer}
                    updaterValue={props.updateStandard('value')('eigentuemer')}
                    updaterTouch={props.updateStandard('touched')('eigentuemer')}
                    updaterValid={props.updateStandard('valid')('eigentuemer')}
                    updaterMsg={props.updateStandard('msg')('eigentuemer')}
                    restLadePlz={props.konfiguration.restPath + 'plz.php'}
                    fehlermeldung={validatorPersonResult(props.data.eigentuemer, true)}
                    konfiguration = {props.konfiguration.importierteKonfiguration.eigentuemer}
                />
            </div>
        </Zoom>
        }




        <Card style={{marginTop:"25px"}}>
                <CardHeader
                    avatar={false}
                    title={<span style={{color:theme.palette.primary.main, marginTop:"10px"}}>Art und Menge</span>}
                />
                <CardContent>
                    <Spezies
                        spezies={props.data.spezies}
                        anzahl={props.data.anzahl}
                        zeigeAnzahl={false}
                        restLadeSpezies={props.konfiguration.restPath + 'spezies.php'}
                        updaterTouched={props.updateStandard('touched')('spezies')()}
                        dispatchSpezies = {
                            (obj)=>{
                            props.dispatch(
                                speziesSetzenCites(obj)
                            )
                            }
                        }
                        dispatchAnzahl = {
                            (anzahl)=>props.dispatch(
                                anzahlSpeziesSetzen(
                                    anzahl,
                                    ['spezies']
                                )
                            )
                        }
                    />

                    <div style={{marginTop:"15px"}}></div>

                    <FormControl component="fieldset">
                        <FormLabel component="legend">Lebend oder Teil</FormLabel>
                        <FormGroup aria-label="position" row>

                            <FormControlLabel
                                value="top"
                                control={
                                    <Checkbox
                                        onChange={()=>{
                                            props.updateStandard('value')('lebend_oder_teil')()("lebend")
                                            props.updateStandard('value')('code')()('LIV')
                                            props.removeStandard(['nettomasse'])()()
                                            props.removeStandard(['menge'])()()
                                        }}
                                        checked={props.data.lebend_oder_teil.value === "lebend"}
                                        sx={{ '& .MuiSvgIcon-root': { fontSize: 28 }}}
                                    />
                                }
                                label="Lebend"
                                labelPlacement="end"
                            />

                            <FormControlLabel
                                value="top"
                                control={
                                    <Checkbox
                                        onChange={()=>{
                                            props.updateStandard('value')('lebend_oder_teil')()("teil")
                                            props.updateStandard('value')('code')()('')
                                            props.updateStandard('value')('haltungsort_vorgeschrieben')()(null)
                                            props.updateStandard(null)('nettomasse')()(StandardDataField())
                                            props.updateStandard(null)('menge')()(StandardDataField())
                                            props.removeStandard(['F02_Haltungsort'])()(StandardDataField())
                                        }}
                                        checked={props.data.lebend_oder_teil.value === "teil"}
                                        sx={{ '& .MuiSvgIcon-root': { fontSize: 28 }}}
                                    />
                                }
                                label="Teile oder Erzeugnisse"
                                labelPlacement="end"
                            />


                        </FormGroup>
                    </FormControl>

                    <Grid container spacing={2}>
                        {props.data.lebend_oder_teil.value == "teil" &&

                            <Grid item xs={12} md={6}>
                                    <F04_WareCodes 
                                        value={props.data.code.value}
                                        updaterValue={props.updateStandard('value')('code')()}
                                    />
                            </Grid>
                        }

                        {props.data.hasOwnProperty("nettomasse") && 
                        <Grid item xs={12} md={3}>
                            <CustomTextFieldNGX
                                label="Nettomasse in kg"
                                data={props.data.nettomasse}
                                updaterValue={props.updateStandard('value')('nettomasse')()}
                                updaterTouch={props.updateStandard('touched')('nettomasse')()}
                                updaterValid={props.updateStandard('valid')('nettomasse')()}
                                required={false}
                                validator={
                                    () => ValidatorInputText(props.data.menge.value, rulesText(false,1))
                                }
                                inputProps={{ 'aria-label': 'Nettomasse in kg' }}
                            />
                        </Grid>
                        }

                        {props.data.hasOwnProperty("menge") && 
                        <Grid item xs={12} md={3}>
                            <CustomTextFieldNGX
                                label="Menge/Anzahl"
                                data={props.data.menge}
                                updaterValue={props.updateStandard('value')('menge')()}
                                updaterTouch={props.updateStandard('touched')('menge')()}
                                updaterValid={props.updateStandard('valid')('menge')()}
                                required={true}
                                validator={
                                    () => ValidatorInputText(props.data.menge.value, rulesText(true,1))
                                }
                                inputProps={{ 'aria-label': 'Menge/Anzahl' }}
                            />
                        </Grid>
                        }

                    </Grid>

                    <div style={{marginTop:"25px"}}></div>

                    {props.data.lebend_oder_teil.value === "lebend" &&
                        <div>
                            <FormControl component="fieldset">
                            <FormLabel component="legend">Gibt es einen vorgeschriebenen Haltungsort?</FormLabel>
                            <FormGroup aria-label="position" row>

                                <FormControlLabel
                                    value="top"
                                    control={
                                        <Checkbox
                                            onChange={()=>{
                                                props.updateStandard('value')('haltungsort_vorgeschrieben')()("ja")
                                                props.updateStandard()('F02_Haltungsort')()(ortEntity())
                                            }}
                                            checked={props.data.haltungsort_vorgeschrieben.value === "ja"}
                                            sx={{ '& .MuiSvgIcon-root': { fontSize: 28 }}}
                                        />
                                    }
                                    label="Ja, Haltungsort ist vorgeschrieben"
                                    labelPlacement="end"
                                />

                                <FormControlLabel
                                    value="top"
                                    control={
                                        <Checkbox
                                            onChange={()=>{
                                                props.updateStandard('value')('haltungsort_vorgeschrieben')()("nein")
                                                props.removeStandard(['F02_Haltungsort'])()()
                                            }}
                                            checked={props.data.haltungsort_vorgeschrieben.value === "nein"}
                                            sx={{ '& .MuiSvgIcon-root': { fontSize: 28 }}}
                                        />
                                    }
                                    label="Nein, kein Haltungsort vorgeschrieben"
                                    labelPlacement="end"
                                />

                            </FormGroup>
                            </FormControl>
                            


                        </div>
                    }

                </CardContent>                
        </Card>

        {props.data.hasOwnProperty("F02_Haltungsort") &&
        <Zoom in={true} timeout={500}>
            <Paper style={{marginTop:"25px", padding:"10px 20px 10px 20px"}}>
                <Ort
                    id="Haltungsort"
                    headline="Ort an dem lebende Exemplare der in Anhang A aufgeführten Arten gehalten werden dürfen"
                    subheader="Authorized location for live specimens of Annex A species"
                    withCard={false}
                    withAvatar={true}
                    data={props.data.F02_Haltungsort}
                    updaterValue={props.updateStandard('value')('F02_Haltungsort')}
                    updaterTouch={props.updateStandard('touched')('F02_Haltungsort')}
                    updaterValid={props.updateStandard('valid')('F02_Haltungsort')}
                    updaterMsg={props.updateStandard('msg')('F02_Haltungsort')}
                    restLadePlz={props.konfiguration.restPath + 'plz.php'}
                />
                <Fehlerbox
                    inhalt={validatorOrtResult(props.data.F02_Haltungsort)}
                />
            </Paper>
        </Zoom>
        }

        {props.data.hasOwnProperty("creatures") &&
                <div>

                    <h1>
                        Beschreibung des Exemplars<br/>
                        <small>Einschließlich Kennzeichen, Geschlecht / Geburtsdatum bei lebenden Exemplaren</small>
                    </h1>

                    <Creatures
                        form={props.form}
                        data={props.data}
                        creatures={props.data.creatures}
                        externeAnzahl={props.data.anzahl}
                        dispatch={props.dispatch}
                        updaterValue={props.updateStandard('value')}
                        updaterTouch={props.updateStandard('touched')}
                        updaterValid={props.updateStandard('valid')}
                        konfiguration={props.konfiguration}
                        creatureExemplar={configCreatureExemplar}
                        creatureParent={null}
                        creatureNachkommen={null}
                        weitereExemplareUnterbinden={false}
                        restLadeSpezies={props.konfiguration.restPath + 'spezies.php'}
                        restPath={props.konfiguration.restPath}
                        kennzeichnungAnpassen={true}
                    />
                </div>

        }

        <div style={{marginTop:"25px"}}></div>

        <Paper style={style.paperHeavy}>
            <FormControl component="fieldset">
            <FormLabel component="legend">Art der Bescheinigung</FormLabel>
            <FormGroup aria-label="position" row>

                <FormControlLabel
                    value="top"
                    control={
                        <Checkbox
                            onChange={()=>{
                                props.updateStandard('value')('art_der_bescheinigung')()("erwerb")
                            }}
                            checked={props.data.art_der_bescheinigung.value === "erwerb"}
                            sx={{ '& .MuiSvgIcon-root': { fontSize: 28 }}}
                        />
                    }
                    label="Rechtmäßiger Erwerb"
                    labelPlacement="end"
                />

                <FormControlLabel
                    value="top"
                    control={
                        <Checkbox
                            onChange={()=>{
                                props.updateStandard('value')('art_der_bescheinigung')()("kommerziell")
                            }}
                            checked={props.data.art_der_bescheinigung.value === "kommerziell"}
                            sx={{ '& .MuiSvgIcon-root': { fontSize: 28 }}}
                        />
                    }
                    label="Kommerzielle Tätigkeit"
                    labelPlacement="end"
                />

                <FormControlLabel
                    value="top"
                    control={
                        <Checkbox
                            onChange={()=>{
                                props.updateStandard('value')('art_der_bescheinigung')()("verbringung")
                            }}
                            checked={props.data.art_der_bescheinigung.value === "verbringung"}
                            sx={{ '& .MuiSvgIcon-root': { fontSize: 28 }}}
                        />
                    }
                    label="Verbringung lebender Exemplare"
                    labelPlacement="end"
                />


                <Button 
                    variant="outlined" 
                    color="primary" 
                    startIcon={props.data.art_der_bescheinigung_info_zeigen.value ? <HelpIcon/> : <HelpOutlineIcon/>}
                    onClick={()=>{
                        props.data.art_der_bescheinigung_info_zeigen.value === true
                        ? props.updateStandard('value')('art_der_bescheinigung_info_zeigen')()(false)
                        : props.updateStandard('value')('art_der_bescheinigung_info_zeigen')()(true)
                    }}
                    >
                    Alle Infos zeigen
                </Button>


            </FormGroup>
            </FormControl>
            <Collapse in={(props.data.art_der_bescheinigung.value == "erwerb" && !props.data.art_der_bescheinigung_info_zeigen.value)}>
                <p>
                    <b>Rechtmäßiger Erwerb</b><br/>
                    Die Bescheinigung des rechtmäßigen Erwerbs dient als Ausweis des rechtmäßigen Besitzes von Exemplaren und ist 
                    bei der Beantragung von Ausfuhrdokumenten zwingend erforderlich.
                </p>
            </Collapse>

            <Collapse in={props.data.art_der_bescheinigung.value == "kommerziell" && !props.data.art_der_bescheinigung_info_zeigen.value}>
                <p>
                    <b>Kommerzielle Tätigkeit</b><br/>
                    Die Bescheinigung für kommerzielle Zwecke berechtigt zur Vermarktung von Exemplaren innerhalb der EU.
                </p>

                {props.data.hasOwnProperty("marktwert") && 

                    <CustomTextFieldNGX
                        label="Marktwert in Euro"
                        data={props.data.marktwert}
                        updaterValue={props.updateStandard('value')('marktwert')()}
                        updaterTouch={props.updateStandard('touched')('marktwert')()}
                        updaterValid={props.updateStandard('valid')('marktwert')()}
                        required={false}
                        validator={
                            () => validatorResult(true)
                        }
                        inputProps={{ 'aria-label': 'Marktwert in Euro' }}
                    />

                }


            </Collapse>

            <Collapse in={props.data.art_der_bescheinigung.value == "verbringung" && !props.data.art_der_bescheinigung_info_zeigen.value}>
                <p>
                    <b>Verbringung lebender Exemplare</b><br/>
                    Die Bescheinigung zur Verbringung berechtigt zum Transport und zur Unterbringung von Exemplaren an 
                    einem anderen als dem in einer Einfuhrgenehmigung eines EU-Mitgliedstaates bestimmten Ort.
                </p>
            </Collapse>

            <Collapse in={props.data.art_der_bescheinigung_info_zeigen.value}>
                <p style={props.data.art_der_bescheinigung.value == "erwerb" ? {fontWeight:"500"} : {fontWeight:"400"}}>
                    <b>Rechtmäßiger Erwerb</b><br/>
                    Die Bescheinigung des rechtmäßigen Erwerbs dient als Ausweis des rechtmäßigen Besitzes von Exemplaren und ist 
                    bei der Beantragung von Ausfuhrdokumenten zwingend erforderlich.
                </p>

                <p style={props.data.art_der_bescheinigung.value == "kommerziell" ? {fontWeight:"500"} : {fontWeight:"400"}}>
                    <b>Kommerzielle Tätigkeit</b><br/>
                    Die Bescheinigung für kommerzielle Zwecke berechtigt zur Vermarktung von Exemplaren innerhalb der EU.
                </p>

                <p style={props.data.art_der_bescheinigung.value == "verbringung" ? {fontWeight:"500"} : {fontWeight:"400"}}>
                    <b>Verbringung lebender Exemplare</b><br/>
                    Die Bescheinigung zur Verbringung berechtigt zum Transport und zur Unterbringung von Exemplaren an 
                    einem anderen als dem in einer Einfuhrgenehmigung eines EU-Mitgliedstaates bestimmten Ort.
                </p>

            </Collapse>

        </Paper>

        <div style={{marginTop:"25px"}}></div>


        <Card style={{marginTop:"25px"}}>
            <CardHeader
                avatar={false}
                title={<span style={{color:theme.palette.primary.main, marginTop:"10px"}}>Herkunft</span>}
            />
            <CardContent>

                <AutocompleteLand
                    label="Ursprungsland"
                    value={props.data.ursprungsland}
                    required={true}
                    updaterValueCode={props.updateStandard('value')('ursprungsland')('code')}
                    updaterTouchCode={props.updateStandard('touched')('ursprungsland')('code')}
                    updaterValueDe={props.updateStandard('value')('ursprungsland')('de')}
                    updaterValueEu={props.updateStandard('value')('ursprungsland')('eu')}
                />

                <div style={{marginTop:"15px"}}></div>

                <AutocompleteLand
                    label="Einfuhrmitgliedsstaat"
                    value={props.data.herkunftsland}
                    required={true}
                    limitEu={true}
                    updaterValueCode={props.updateStandard('value')('herkunftsland')('code')}
                    updaterTouchCode={props.updateStandard('touched')('herkunftsland')('code')}
                    updaterValueDe={props.updateStandard('value')('herkunftsland')('de')}
                    updaterValueEu={props.updateStandard('value')('herkunftsland')('eu')}
                />


                {(props.data.ursprungsland.eu.value !== true || props.data.herkunftsland.eu.value !== true) &&
                    <Card variant="outlined" style={{marginTop:"15px"}}>
                        <CardContent>
                        <Typography sx={{ fontSize: "1rem" }} color="text.secondary" gutterBottom>
                            Einfuhrgenehmigung
                        </Typography>
                            <Grid container spacing={2}>
                                <Grid item xs={12} md={6}>
                                    <CustomTextFieldNGX
                                        label="Nummer der Einfuhrgenehmigung"
                                        data={props.data.einfuhrgenehmigung_nummer}
                                        updaterValue={props.updateStandard('value')('einfuhrgenehmigung_nummer')()}
                                        updaterTouch={props.updateStandard('touched')('einfuhrgenehmigung_nummer')()}
                                        updaterValid={props.updateStandard('valid')('einfuhrgenehmigung_nummer')()}
                                        required={false}
                                        validator={
                                            () => validatorResult(true)
                                        }
                                        inputProps={{ 'aria-label': 'Nummer der Einfuhrgenehmigung' }}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <CustomDatePickerFieldNGX
                                        label="Ausstellungsdatum der Einfuhrgenehmigung"
                                        value={props.data.einfuhrgenehmigung_ausstellungsdatum.value}
                                        updaterValue={props.updateStandard('value')('einfuhrgenehmigung_ausstellungsdatum')()}
                                        updaterTouch={props.updateStandard('touched')('einfuhrgenehmigung_ausstellungsdatum')()}
                                        required={false}
                                        ariaLabel="Ausstellungsdatum der Einfuhrgenehmigung"
                                    />
                                </Grid>
                            </Grid>

                            <div style={{textAlign:"center"}}>
                                <DokumenteUploader
                                    dokumente={props.data.einfuhrgenehmigung_dokumente}
                                    restPath={props.konfiguration.restPath}
                                    dispatch={props.dispatch}
                                    lineage={['einfuhrgenehmigung_dokumente']}
                                    label="Einfuhrgenehmigung des BFN"
                                    labelButton="Einfuhrgenehmigung des BFN hochladen"
                                    buttonSize="large"
                                    buttonVariant="outlined"
                                    buttonFullWidth={false}
                                    style={{marginTop:"10px"}}
                                />
                            </div>

                        </CardContent>
                    </Card>
                }

                {(props.data.ursprungsland.eu.value !== true || props.data.herkunftsland.eu.value !== true) &&
                    <Card variant="outlined" style={{marginTop:"15px"}}>
                        <CardContent>
                        <Typography sx={{ fontSize: "1rem" }} color="text.secondary" gutterBottom>
                            Ausfuhrgenehmigung
                        </Typography>
                            <Grid container spacing={2}>
                                <Grid item xs={12} md={6}>
                                    <CustomTextFieldNGX
                                        label="Nummer der Ausfuhrgenehmigung"
                                        data={props.data.ausfuhrgenehmigung_nummer}
                                        updaterValue={props.updateStandard('value')('ausfuhrgenehmigung_nummer')()}
                                        updaterTouch={props.updateStandard('touched')('ausfuhrgenehmigung_nummer')()}
                                        updaterValid={props.updateStandard('valid')('ausfuhrgenehmigung_nummer')()}
                                        required={false}
                                        validator={
                                            () => validatorResult(true)
                                        }
                                        inputProps={{ 'aria-label': 'Nummer der Einfuhrgenehmigung' }}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <CustomDatePickerFieldNGX
                                        label="Ausstellungsdatum der Ausfuhrgenehmigung"
                                        value={props.data.ausfuhrgenehmigung_ausstellungsdatum.value}
                                        updaterValue={props.updateStandard('value')('ausfuhrgenehmigung_ausstellungsdatum')()}
                                        updaterTouch={props.updateStandard('touched')('ausfuhrgenehmigung_ausstellungsdatum')()}
                                        required={false}
                                        ariaLabel="Ausstellungsdatum der Ausfuhrgenehmigung"
                                    />
                                </Grid>
                            </Grid>

                            <div style={{textAlign:"center"}}>
                                <DokumenteUploader
                                    dokumente={props.data.ausfuhrgenehmigung_dokumente}
                                    restPath={props.konfiguration.restPath}
                                    dispatch={props.dispatch}
                                    lineage={['ausfuhrgenehmigung_dokumente']}
                                    label="Ausfuhrgenehmigung"
                                    labelButton="Ausfuhrgenehmigung"
                                    buttonSize="large"
                                    buttonVariant="outlined"
                                    buttonFullWidth={false}
                                    style={{marginTop:"10px"}}
                                />
                            </div>

                        </CardContent>
                    </Card>
                }

                {props.data.ursprungsland.eu.value === false && props.data.herkunftsland.eu.value === true &&
                    <Card variant="outlined" style={{marginTop:"15px"}}>
                        <CardContent>
                        <Typography sx={{ fontSize: "1rem" }} color="text.secondary" gutterBottom>
                            EU-Bescheinigung über rechtmäßigen Erwerb
                        </Typography>
                            <Grid container spacing={2}>
                                <Grid item xs={12} md={6}>
                                    <CustomTextFieldNGX
                                        label="Nummer der EG Bescheinigung über rechtmäßigen Erwerb"
                                        data={props.data.cites_bescheinigung_rechtmaessiger_erwerb_nummer}
                                        updaterValue={props.updateStandard('value')('cites_bescheinigung_rechtmaessiger_erwerb_nummer')()}
                                        updaterTouch={props.updateStandard('touched')('cites_bescheinigung_rechtmaessiger_erwerb_nummer')()}
                                        updaterValid={props.updateStandard('valid')('cites_bescheinigung_rechtmaessiger_erwerb_nummer')()}
                                        required={false}
                                        validator={
                                            () => validatorResult(true)
                                        }
                                        inputProps={{ 'aria-label': 'Nummer der cites_bescheinigung_rechtmaessiger_erwerb_' }}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <CustomDatePickerFieldNGX
                                        label="Ausstellungsdatum der EU-Bescheinigung über rechtmäßigen Erwerb"
                                        value={props.data.cites_bescheinigung_rechtmaessiger_erwerb_ausstellungsdatum.value}
                                        updaterValue={props.updateStandard('value')('cites_bescheinigung_rechtmaessiger_erwerb_ausstellungsdatum')()}
                                        updaterTouch={props.updateStandard('touched')('cites_bescheinigung_rechtmaessiger_erwerb_ausstellungsdatum')()}
                                        required={false}
                                        ariaLabel="Ausstellungsdatum der cites_bescheinigung_rechtmaessiger_erwerb_"
                                    />
                                </Grid>
                            </Grid>

                            <div style={{textAlign:"center"}}>
                                <DokumenteUploader
                                    dokumente={props.data.cites_bescheinigung_rechtmaessiger_erwerb_dokumente}
                                    restPath={props.konfiguration.restPath}
                                    dispatch={props.dispatch}
                                    lineage={['cites_bescheinigung_rechtmaessiger_erwerb_dokumente']}
                                    label="EU-Bescheinigung über rechtmäßigen Erwerb"
                                    labelButton="EU-Bescheinigung über rechtmäßigen Erwerb"
                                    buttonSize="large"
                                    buttonVariant="outlined"
                                    buttonFullWidth={false}
                                    style={{marginTop:"10px"}}
                                />
                            </div>

                        </CardContent>
                    </Card>
                }

                <div style={{marginTop:"25px"}}></div>
                {/*
                <CustomList
                    id={"codeHerkunft"}
                    label="Herkunft"
                    value={props.data['codeHerkunft'].value}
                    updaterValue={props.updateStandard('value')('codeHerkunft')()}
                    touched={props.data['codeHerkunft'].touched}
                    updaterTouch={props.updateStandard('touched')('codeHerkunft')()}
                    variant="list"
                    list={ListeHerkunftCodes}
                    required={true}
                    validator={()=>{
                        if( props.data.codeHerkunft.touched && !props.data.codeHerkunft.value ) {
                            props.updateStandard('valid')('codeHerkunft')(false)
                            return validatorResult(false, "Bitte treffen Sie eine Auswahl");
                        }
                        return validatorResult(true);
                    }}
                />
                */}

            </CardContent>
                
        </Card>

        <div style={{marginTop:"25px"}}></div>


        <Card style={{marginTop:"25px"}}>
            <CardHeader
                avatar={false}
                title={<span style={{color:theme.palette.primary.main, marginTop:"10px"}}>Dokumente</span>}
            />
            <CardContent>
                <p>
                Bitte laden Sie hier alle vorhandenen Dokumente, die das Tier betreffen, hoch. 
                </p>

                <DokumenteUploader
                    dokumente={props.data.dokumente_herkunft}
                    restPath={props.konfiguration.restPath}
                    dispatch={props.dispatch}
                    lineage={['dokumente_herkunft']}
                    label="Dokumente zur Herkunft"
                    labelButton={<span>Dokumente zur Herkunft hochladen</span>}
                    buttonSize="large"
                    buttonVariant="contained"
                    buttonFullWidth={false}
                    style={{marginTop:"10px"}}
                />

            </CardContent>
                
        </Card>

        <div style={{marginTop:"25px"}}></div>

        <UnterschriftHaken 
          value={props.data.meta.unterschrifthaken.value}
          update={props.updateStandard('value')('meta')('unterschrifthaken')}
        />

        <div style={{marginTop:"25px"}}></div>

        {props.data.meta &&
            absenden(props)
        }

        </div>
    )
}

export default render;